$(document).on('click', '#js-svg-lightbox-close', function () {
  $('#js-svg-lightbox').removeClass('active');
});

$(document).on('change', '.js-svg-checkbox', function () {
  $('.mm-svg').toggleClass($(this).val());
});

$(document).on('click', '.mm-svg .nhs-icon svg *:not([id])', function () {
  $('#js-svg-lightbox').removeClass('active');
});

$(document).on('click', '.mm-svg svg [id] > [id]', function (e) {
  // console.log(e)
  var id = $(this).attr('id');
  // console.log('click');
  if (id) {
    // console.log(id);
    var content = $('#lightbox_' + id).html();

    if(content)
    $('#js-svg-lightbox').addClass('active');

    $('#js-svg-lightbox-content').html(content);

    console.log($(this).attr('id'));
    console.log(content)
  }
  $(document).keyup(function (e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
      $('#js-svg-lightbox').removeClass('active');
    }
  });
});
